import BirdsViewVideo from "./birdsViewVideo";
export default BirdsViewVideo;
